import { createStore } from "vuex";

/***  Import Modules here  ***/
import api from "./Api/store.api";
import auth from "./Auth/store.auth";

/***  Import Persistence here  ***/
import persistenceAuth from "../_persistence/persistence.auth";

const store = createStore({
  modules: {
    api,
    auth,
  },
  plugins: [persistenceAuth.plugin],
});

export default store;
